export default __webpack_public_path__ + "static/media/section3-img2.789be93b.png";